<div class="live-session-banner" *ngIf="visible" role="status" aria-live="polite">
  <span class="live-pill"><span class="live-dot" aria-hidden="true"></span>Live</span>
  <span class="banner-icon" aria-hidden="true"><mat-icon>podcasts</mat-icon></span>
  <span class="message">
    <span class="eyebrow">Live film session</span>
    <span class="headline">
      <strong>{{ session.createdByName || 'Your coach' }}</strong> is presenting
      <strong>{{ session.title || 'film' }}</strong>
    </span>
  </span>
  <button mat-flat-button color="primary" class="join-button" (click)="join()">
    <mat-icon>login</mat-icon>
    Join
  </button>
  <button mat-icon-button class="dismiss-button" aria-label="Dismiss" (click)="dismiss()">
    <mat-icon>close</mat-icon>
  </button>
</div>
